import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { VaccineController } from 'src/controllers/vaccine.controller'
import { VaccineDto } from 'src/dto/vaccine.dto'

const useController = new VaccineController()

export function useGetVaccineList() {
  const { userFarm: farmId } = useAuth()

  return useQuery<VaccineDto[], Error>({
    queryKey: ['getVaccineList'],
    queryFn: () => useController.getVaccineList(),
    enabled: !!farmId
  })
}
